export const generativeAiAppGroupIdBrandGuidelinesSynthesis =
  "/:app_group_id/generative_ai/brand_guidelines_synthesis";
